import React, { useState } from "react" 
import { useParams } from "react-router-dom"
import _ from "lodash"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, randoms } from "lib/utils"

export default function useTemplate(_Template:any){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()
  const { update }:any = AppStore 

  const [ reloadTemplate, setReloadTemplate ] = useState(false)

  // const { data:_Template } = queryTools.resource.parseQueryForApi(
  //   "template.findById", 
  //   { _id: tmplid }, 
  //   { enabled: (!!tmplid && !!reloadTemplate) }
  // )


  const addStatement = (statement:any, callbackFn?:any) => {
    console.log(store.element.refstr)
    const clone = _.cloneDeep(_Template)
    const newTmpl = clone.Elements.map((elem:any) => {
      if( elem.refstr !== store.element.refstr ) return elem
      return {
        ...elem,
        config: {
          ...elem.config,
          statements: [
            ...elem.config.statements,
            { ...statement, parent: "[root]", level: 1, parentResult: "any" }
          ]
        }
      }
    })
    const finalTmpl = { ...clone, Elements: newTmpl }
    if( callbackFn ){
      callbackFn(finalTmpl)
    } else {
      return finalTmpl
    }
  }

  const updateStatement = (statement:any, callbackFn?:any) => {
    const clone = _.cloneDeep(_Template)
    const newTmpl = clone.Elements.map((elem:any) => {
      if( elem.refstr !== store.element.refstr ) return elem
      return {
        ...elem,
        config: {
          ...elem.config,
          statements: elem.config.statements.map( (st:any) => {
            return ( st.refstr !== statement.refstr ) ? st : statement
          })
        }
      }
    })
    return { ...clone, Elements: newTmpl }
  }


  const removeStatement = (template:any, statementRefStr:string, callbackFn?:any) => {
    console.log("remove statement", statementRefStr)
    const updatedTmpl = {
      ...template,
      Elements: template.Elements.map( (elem:any) => {
        if( elem.refstr !== store.element.refstr ) return elem
        return {
          ...elem,
          config: {
            ...elem.config,
            statements: elem.config.statements.filter( (st:any) => st.refstr !== statementRefStr )
          }
        }
      })
    }
    if( callbackFn ){
      callbackFn(updatedTmpl)
    } else {
      return updatedTmpl
    }
  }



  const replaceStatement = (template:any, statement:any, callbackFn?:any) => {
    const clone = _.cloneDeep(template)
    const newTmpl = clone.Elements.map((elem:any) => {
      if( elem.refstr !== store.element.refstr ) return elem
      return {
        ...elem,
        config: {
          ...elem.config,
          statements: elem.config.statements.map( (st:any) => {
            if( st.refstr !== statement.refstr ) return st
            return statement
          })
        }
      }
    })
    return newTmpl
  }


  const updateContent = (template:any) => {
    const updatedTmpl:any = {
      ...template,
      Elements: template.Elements.map( (elem:any) => {
        if( elem.refstr !== store.element.refstr ) return elem
        return {
          ...elem,
          config: {
            ...elem.config,
            statements: elem.config.statements.map( (st:any) => {
              if( st.refstr !== store.actives.statement.refstr ) return st
              return {
                ...st,
                content: {
                  pass: store.actives.statement.content.pass,
                  fail: store.actives.statement.content.fail
                }
              }
            }
          )}
        }
      })
    }
    return updatedTmpl
  }



  const templateTools = {
    statement: {
      add: addStatement,
      remove: removeStatement,
      replace: replaceStatement,
      update: updateStatement,
      updateContent: updateContent
    }
  }

  return {
    templateTools,
  }
}